import { Button, Colors, Icon } from "swing-components";

import { translate } from "~utils";

type RequestAlreadyFilledModalProps = {
  onDismiss: () => void;
  onViewOpenings: () => void;
};

export function RequestAlreadyFilledModal(props: RequestAlreadyFilledModalProps) {
  const { onDismiss, onViewOpenings } = props;

  return (
    <div
      css={{
        backgroundColor: Colors.white200,
        borderRadius: 16,
        padding: 24,
      }}
    >
      <div
        css={{
          alignItems: "flex-start",
          display: "flex",
          gap: 16,
          justifyContent: "space-between",
        }}
      >
        <div>
          <h2
            css={{
              color: Colors.black,
              fontSize: 24,
              lineHeight: "32px",
              margin: 0,
            }}
          >
            {translate("REQUEST_ALREADY_FILLED_TITLE")}
          </h2>
          <p
            css={{
              color: Colors.black,
              margin: "12px 0 0",
            }}
          >
            {translate("REQUEST_ALREADY_FILLED_CONTENT")}
          </p>
        </div>
        <button
          aria-label="Close"
          onClick={onDismiss}
          css={{ backgroundColor: "transparent", padding: 0 }}
        >
          <Icon name="Close" color={Colors.blue500} />
        </button>
      </div>
      <div css={{ marginTop: 24 }}>
        <Button isFluid type="primary" onClick={onViewOpenings}>
          {translate("REQUEST_ALREADY_FILLED_CTA")}
        </Button>
      </div>
    </div>
  );
}
